import { styled } from "styled-components";

import { useAppSelector } from "store";

import MessageTray from "components/lib/Messaging/MessageTray";

const MessagesContainer = styled.div`
  background-color: #fff;
  padding: 1rem;
`;

const MobileMessageWidget = () => {
  const user = useAppSelector((state) => state.user);
  if (!user) return null;
  return (
    <MessagesContainer>
      <MessageTray isMobile />
    </MessagesContainer>
  );
};

export default MobileMessageWidget;
